import type { ModalService } from './../../../ricos-modals';

import { QuickActionsModal } from '../modal/modal';
import { QUICK_ACTIONS_MODAL_ID } from '../types';

export type toggleQuickActionsModalProps = {
  modalService: ModalService;
  referenceElement: HTMLDivElement | null;
};

export const toggleQuickActionsModal = (props: toggleQuickActionsModalProps) => {
  const { modalService, referenceElement } = props;
  modalService.isModalOpen(QUICK_ACTIONS_MODAL_ID)
    ? modalService.closeModal(QUICK_ACTIONS_MODAL_ID)
    : modalService.openModal({
        id: QUICK_ACTIONS_MODAL_ID,
        Component: QuickActionsModal,
        componentProps: { openedThroughModalService: true },
        layout: 'floating',
        onClickOutside: {
          on: 'pointerdown',
          handler: (e: PointerEvent) => {
            const isToggleButton =
              e.target === referenceElement || referenceElement?.contains(e.target as Node);
            if (isToggleButton) {
              return;
            }
            modalService.closeModal(QUICK_ACTIONS_MODAL_ID);
          },
        } as { on: 'pointerdown'; handler: (e: PointerEvent) => void },
        positioning: {
          referenceElement,
          placement: 'bottom-end',
        },
        autoFocus: true,
        returnFocusOnDeactivate: true,
        type: 'exclusive',
      });
};
